export const templateSearchItem = (data) =>
    `<div class="card mb-3">
        <div class="card-body p-2 media flex-column flex-md-row align-items-stretch">
            <img width="191" height="130" src="${data.icon}" class="mr-3" alt="${data.name}">
            <div class="media-body d-flex flex-column justify-content-between">
                <div class="d-flex mb-2 justify-content-between align-items-start">
                    <h5 class="mb-0 mr-3">
                        <a href="${data.myOrderLink}" class="link" onclick="set_search_marker()">
                            <b class="text-name">${data.name}</b>
                        </a>
                    </h5>
                    <div class="star__rating star__rating--${data.rating}">
                        <i class="fa fa-star" aria-hidden="true"></i>
                    </div>
                </div>
                <div>
                    <b>Адрес: </b> ${data.actual_address} 
                    (<span class="link dashed js-set-map-center" 
                        data-map-id="${data.itemMapId}" 
                        data-lat="${data.lat}" 
                        data-lon="${data.lon}">
                            На карте
                    </span>)
                </div>
                <div>
                    <b>Телефон: </b> ${data.phone}
                    <span class="${data.ext_phoneclass}">
                        <b>Добавочный:</b> ${data.ext_phone}
                    </span>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                    <div class="${data.distanceclass}">
                        <i class="fas fa-map-marker-alt"></i> ~ ${data.distance} км от вас
                    </div>
                    <a href="${data.myOrderLink}" 
                        class="btn btn-sm btn-outline-tochki-secondary ${data.onlinerecordclass}" 
                        onclick="set_search_marker()">
                        Записаться
                    </a>
                    <a href="${data.myLink}" 
                        class="btn btn-sm btn-outline-tochki-primary" 
                        onclick="set_search_marker()">
                        Подробнее
                    </a>
                </div>
            </div>
        </div>
    </div>`;
